import React from 'react';
import { NavLink } from 'react-router-dom';

type MegaMenuProps = { columns: { name: string; pageId: string; }[][] };

const MegaMenu: React.FC<MegaMenuProps> = ({ columns }) => {
  const columnWidthClass = columns.length === 1 ? 'w-full' : columns.length === 2 ? 'w-1/2' : 'w-1/3';
  const minWidth = columns.length * 150 + (columns.length - 1) * 32 + 32;

  return (
    <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 bg-white shadow-xl z-10 rounded-lg border border-gray-100 p-4" style={{ minWidth: `${minWidth}px` }}>
      <div className="flex justify-between space-x-8">
        {columns.map((column, colIndex) => (
          <div key={colIndex} className={`flex flex-col ${columnWidthClass}`}>
            <ul className="space-y-1">
              {column.map((item) => (
                <li key={item.name}>
                  <NavLink to={`/${item.pageId}`} className={({ isActive }) => `block w-full text-left p-2 text-gray-700 rounded-md transition-all duration-150 hover:bg-gray-50 hover:text-gray-900 ${isActive ? 'font-bold text-gray-900 bg-gray-100' : ''}`}>
                    {item.name}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MegaMenu;
